$(document).ready(function () {

  if($('#drawer-testimonials-slider').length > 0){
    var drawer_testimonial = new Swiper('#drawer-testimonials-slider',{
      slidesPerView: 1,
      spaceBetween: 10,
    });
  }

  if($('#mobile-nav-grid').length > 0){
    var on_load_get_category = $('#mobile-nav-grid .nav-filter__button.active').data('grid-cat');
    $('.mobile-nav__img-tiles .mobile-nav-img-tile').each(function () {
      if($(this).data('grid-cat') == on_load_get_category){
        $(this).parent('li').removeClass('hidden');
      }else{
        $(this).parent('li').addClass('hidden');
      }
    });
    $('#mobile-nav-grid .nav-filter__button').click(function (e) {
      e.preventDefault();
      var cat = $(this).data('grid-cat');
      $(this).addClass('active').siblings('.nav-filter__button').removeClass('active');
      $('.mobile-nav__img-tiles .mobile-nav-img-tile').each(function () {
        if($(this).data('grid-cat') == cat){
          $(this).parent('li').removeClass('hidden');
        }else{
          $(this).parent('li').addClass('hidden');
        }
      });
    })
  }

  if($('.footer .footer-block__heading').length > 0){
    $('.footer .footer-block__heading').click(function (e) {
      e.preventDefault();
      var curret_head = $(this);
      $(this).parents('.footer-block').toggleClass('active');
      $(this).toggleClass('active');
      $(this).next('.footer-content-block-wrap').slideToggle();
      if($(this).hasClass('active')){
        setTimeout(function (){curret_head.parents('.footer-block').addClass('animate-block');},100);
      }
      else{
        $(this).parents('.footer-block').removeClass('animate-block');
      }
    });
  }


  // ------ Main Banner
  if($('.main-banner').length > 0){
    function main_banner_height(){
      let header = ($('.announcement-bar-section').length > 0)? $('.section-header').outerHeight() + $('.announcement-bar-section').outerHeight() : $('.section-header').outerHeight();
      $('.main-banner.desktop-full-screen').css('--banner-full-height',($(window).height() - header + 'px'));
      $('.main-banner.mobile-full-screen').css('--banner-full-height-m',($(window).height() - header + 'px'));
    }
    main_banner_height();
    $(window).on('resize',function(){
      main_banner_height();
    });
  }
  // ------ Main Banner
  

  // ------ Banner Image
  if($('.banner-image').length > 0){
    function banner_image_height(){
      let banner_image_header = $('.section-header').outerHeight();
      $('.banner-image.desktop-full-screen').css('--banner-full-height',($(window).height() - banner_image_header + 'px'));
      $('.banner-image.mobile-full-screen').css('--banner-full-height-m',($(window).height() - banner_image_header + 'px'));
    }
    banner_image_height();
    $(window).on('resize',function(){
      banner_image_height();
    });
  }
  // ------ Banner Image


  // ------ Collection Hero
  if($('.collection-hero').length > 0){
    function collection_banner_height(){
      let collection_image_header = $('.section-header').outerHeight();
      $('.collection-hero.desktop-full-screen').css('--banner-full-height',($(window).height() - collection_image_header + 'px'));
      $('.collection-hero.mobile-full-screen').css('--banner-full-height-m',($(window).height() - collection_image_header + 'px'));
    }
    collection_banner_height();
    $(window).on('resize',function(){
      collection_banner_height();
    });
  }
  // ------ Collection Hero


  // ------ Sort Popup
  if($('.sort_by-popup').length > 0){
    $(document).on('click','.sort_by-popup #sort_by-popup-btn',function (e) {
      e.preventDefault();
      $(this).parent('.sort_by-popup').toggleClass('open_popup');
    });
    $('body').on('click',function(event){
       if(!$(event.target).is('.sort_by-popup') && !$(event.target).is('#sort_by-popup-btn')){
         $(".sort_by-popup").removeClass("open_popup");
       }
    });
  }
  // ------ Sort Popup


  // ------ Facet
  if($('#mobile-facets__toggle').length > 0){
    $('#mobile-facets__toggle').click(function () {
      // $(this).toggleClass('active');
      // $(this).parents('.mobile-facets__disclosure').toggleClass('menu-opening');
      $('body').toggleClass('overflow-hidden');
    });
    $(document).on('click', '#mobile-facet-close',function (e) {
      e.preventDefault();
      $('#mobile-facets__toggle').click();
      $('body').removeClass('overflow-hidden');
    });
  }

  if($('.mobile-facets__details').length > 0){
    // function mobile_facet_block() {
    //   if($(window).width() > 749){
    //     $('.mobile-facets__details:not([open]) summary').click();
    //   }else{
    //     $('#FacetsWrapperMobile').removeClass('submenu-open');
    //     $('.mobile-facets__details.menu-opening').removeClass('menu-opening');
    //     $('.mobile-facets__details[open] summary').click();
    //   }
    // }
    // mobile_facet_block();
    // $(window).on('resize',function () {
    //   mobile_facet_block();
    // })
  }


  // ------  Faq Block
  if($('[data-faq-block]').length > 0){
    $(document).on('click','[data-faq-block] [data-faq-toggle]',function (e) {
      e.preventDefault();
      let curret_block = $(this);
      $(this).next('[data-faq-content]').slideToggle(350).parents('[data-faq-block]').toggleClass('active');
      if($(this).parents('[data-faq-block]').hasClass('active')){
        setTimeout(function (){curret_block.parents('[data-faq-block]').addClass('animate-block');},100);
      }
      else{
        $(this).parents('[data-faq-block]').removeClass('animate-block');
      }
    });
  }
  // ------  Faq Block


  // ------  Product content Model
  $(document).on('click','[data-product-model-close]',function (e) {
    e.preventDefault();
    $('.product-model-content').removeClass('open-model');
    $('body').removeClass('overflow-hidden');
  });
  $(document).on('click','[data-open-model]',function (e) {
    e.preventDefault();
    $('[data-product-model].open-model').removeClass('open-model');
    var model = $(this).data('open-model');
    $('[data-product-model="'+ model +'"]').addClass('open-model');
    $('body').addClass('overflow-hidden');
  });
  // ------  Product content Model
  

  // ------  Product About fabric tab
  if($('[data-about-fabric-toggle]').length > 0){
    $(document).on('click','[data-about-fabric-toggle]',function (e) {
      e.preventDefault();
      var tab = $(this).data('about-fabric-toggle');
      $(this).addClass('current').siblings('[data-about-fabric-toggle]').removeClass('current');
      $(this).parents('.about-fabric-and-care').find('[data-about-fabric-tab="'+tab+'"]').show().siblings('[data-about-fabric-tab]').hide();
    });
  }
  // ------  Product About fabric tab


  // ------  Size chart toggle
  if($('.size-chart-toggles').length > 0){
    $(document).on('click','.size-chart-toggles .size-chart-toggle',function (e) {
      e.preventDefault();
      var size_unit = $(this).data('unit');
      $(this).addClass('active').siblings('.size-chart-toggle').removeClass('active');
      $(this).parents('.size-chart-tables').find('[data-table-unit="' + size_unit +'"]').removeClass('hidden').siblings('[data-table-unit]').addClass('hidden');
    });
  }
  // ------  Size chart toggle


  // ------  Sub Nav Section
  if($('#sub-navigation-list').length > 0){
    $('#sub-navigation-list').click(function (e) {
      $(this).toggleClass('open').find('.sub-nav-items-wrap').slideToggle();
    });
  }
  // ------  Sub Nav Section


  // ------ Background Media Text
  if($('.background-media-text').length > 0){
    function main_banner_height(){
      let header = ($('.announcement-bar-section').length > 0)? $('.section-header').outerHeight() + $('.announcement-bar-section').outerHeight() : $('.section-header').outerHeight();
      $('.background-media-text.desktop-full-screen').css('--banner-full-height',($(window).height() - header + 'px'));
      $('.background-media-text.mobile-full-screen').css('--banner-full-height-m',($(window).height() - header + 'px'));
    }
    main_banner_height();
    $(window).on('resize',function(){
      main_banner_height();
    });
  }
  // ------ Background Media Text

  var screenLoading = false;
  var screenDelay = 100;

  function pInfScrExecute() {
    var loadingImage,loadingmore;
    pInfScrNode = $('.load-more-block').last();
    pInfScrmore = $('.load-more-block [data-load]').last();
    pInfScrURL = $('.load-more-block [data-load]').last().attr("data-href");
    if(!screenLoading && pInfScrNode.length > 0  && pInfScrNode.css('display') != 'none') {
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          screenLoading = true;
          loadingImage = pInfScrNode.clone().empty().append('<img src="https://cdn.shopify.com/s/files/1/0613/6699/3117/files/loading.gif?v=1645597902" />');
          loadingImage.insertAfter(pInfScrNode);
          pInfScrNode.hide();
          pInfScrmore.hide();
          pInfScrNode.remove();
        },
        success: function(data) {
          pInfScrNode.next().remove();
          pInfScrmore.next().remove();
          var filteredData = $(data).find("[data-load-content]").html();
          $('[data-load-content]').append(filteredData);
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          loadingImage.remove();
          screenLoading = false;
        },
        dataType: "html"
      });

    }
  }

  if (document.querySelector("[data-load-content]")) {
    $(window).scroll(function(){
      setTimeout(function(){
        pInfScrExecute();
      }, screenDelay);
      if( $(document).height() - 1500 > $(document).scrollTop() + $(window).height() ) {
        screenDelay = 100;
      }
    }); 
  }

  // _________________  Complete the look
    if ($('.compelete-the-look').length > 0) {
      var product__loop = ($('#compelete-the-look-products .swiper-slide').length > 2)? true : false;
      var comelete_the_look = new Swiper('#compelete-the-look-products' ,{
        slidesPerView: 'auto',
        spaceBetween: 15,
        loop: true,
        mousewheel: {
          forceToAxis: true
        },
        navigation: {
          nextEl: '.compelete-the-look .swiper-button-next',
          prevEl: '.compelete-the-look .swiper-button-prev',
        }
      });
    }
  // _________________  Complete the look


  // Collection Grid Layout Toggles
  $(function () {
    var $grid      = $('#product-grid');
    var $toggleBox = $('#GridToggle');
  
    if (!$grid.length || !$toggleBox.length) return;
  
    // delegate click to any .grid-toggle__btn inside the toggle box
    $toggleBox.on('click', '.grid-toggle__btn', function () {
      var $btn  = $(this);
      var cols  = $btn.data('cols');              // "4" or "6"
  
      // highlight the active button
      $toggleBox.find('.grid-toggle__btn').removeClass('is-active');
      $btn.addClass('is-active');
  
      // swap the grid classes
      $grid
        .removeClass('grid--4-col-desktop grid--6-col-desktop')
        .addClass('grid--' + cols + '-col-desktop');
    });
  });

  
  const sizeVariantInputs = document.querySelectorAll('[data-size-variant-input]');
  
  if (sizeVariantInputs.length > 0) {
    sizeVariantInputs.forEach(radio => (radio.checked = false));
  }
  
});


if($('[data-parallax-image]').length > 0){
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      this.parallaxImage = this.querySelector('[data-parallax-image]');
      this.windowInnerHeight = window.innerHeight;
      this.isActive = false;
      this.timeout = null;
      this.directionMap = {
        right: 0,
        top: 90,
        left: 180,
        bottom: 270
      }
      this.directionMultipliers = {
        0: [  1,  0 ],
        90: [  0, -1 ],
        180: [ -1,  0 ],
        270: [  0,  1 ]
      }
  
      this.init();
      window.addEventListener('scroll', () => this.scrollHandler());
    }
  
    getParallaxInfo() {
      const { width, height, top } = this.parallaxImage.getBoundingClientRect();
      let element = this.parallaxImage;
      let multipliers;
      let { angle, movement } = element.dataset;
  
      let movementPixels = angle === 'top' ? Math.ceil(height * (parseFloat(movement) / 100)) : Math.ceil(width * (parseFloat(movement) / 100));
  
      // angle has shorthands "top", "left", "bottom" and "right"
      // nullish coalescing. using `||` here would fail for `0`
      angle = this.directionMap[angle] ?? parseFloat(angle);
  
      // fallback if undefined
      // NaN is the only value that doesn't equal itself
      if (angle !== angle) angle = 270; // move to bottom (default parallax effect)
      if (movementPixels !== movementPixels) movementPixels = 100; // 100px
  
      // check if angle is located in top half and/or left half
      angle %= 360;
      if (angle < 0) angle += 360
  
      const toLeft = angle > 90 && angle < 270;
      const toTop  = angle < 180;
  
      element.style[toLeft ? 'left' : 'right'] = 0;
      element.style[toTop  ? 'top' : 'bottom'] = 0;
  
      // if it's not a perfectly horizontal or vertical movement, get cos and sin
      if (angle % 90) {
        const radians = angle * Math.PI / 180
        multipliers = [ Math.cos(radians), Math.sin(radians) * -1 ] // only sin has to be inverted
      } else {
        multipliers = this.directionMultipliers[angle];
      }
  
      // increase width and height according to movement and multipliers
      if (multipliers[0]) element.style.width  = `calc(100% + ${movementPixels * Math.abs(multipliers[0])}px)`;
      if (multipliers[1]) element.style.height = `calc(100% + ${movementPixels * Math.abs(multipliers[1])}px)`;
  
      return {
        element,
        movementPixels,
        multipliers,
        top,
        height
      }
    }
  
    init() {
      const { element, movementPixels, multipliers, top, height } = this.getParallaxInfo();;
  
      const scrolledInContainer = this.windowInnerHeight - top;
      const scrollArea = this.windowInnerHeight + height;
      const progress = scrolledInContainer / scrollArea;
  
      if (progress > -0.1 && progress < 1.1) {
        const position = Math.min(Math.max(progress, 0), 1) * movementPixels;
        element.style.transform = `translate3d(${position * multipliers[0]}px, ${position * multipliers[1]}px, 0)`;
      }
  
      if (this.isActive) requestAnimationFrame(this.init.bind(this));
    }
  
    scrollHandler() {
      if (this.isActive) {
        clearTimeout(this.timeout);
      } else {
        this.isActive = true;
        requestAnimationFrame(this.init.bind(this));
      }
  
      this.timeout = setTimeout(() => this.isActive = false, 20);
    }
  }
  
  customElements.define('parallax-image', ParallaxImage);
}


// Injecting Global-e Free Shipping Banner Text into the Product Free Shipping Benefits Text
(function ($) {
  const SOURCE_SEL = '.ge-free-shipping-msg';   // app-injected element
  const TARGET_SEL = '#product-shipping-benefit'; // block that needs the message

  // Copies the text once both elements exist & the source has content
  function moveText () {
    const $src = $(SOURCE_SEL);
    const $tgt = $(TARGET_SEL);

    if ($src.length && $tgt.length) {
      const txt = $.trim($src.text());
      if (txt) {
        // If your target has an inner text container, swap that instead:
        // $tgt.find('.icon-with-text__text').text(txt);
        $tgt.text(txt);
        return true;        // success
      }
    }
    return false;           // try again later
  }

  $(document).ready(function () {
    if (moveText()) return; // it was already there on load

    // Poll every 250 ms until the shipping message appears, then stop
    const pollId = setInterval(function () {
      if (moveText()) clearInterval(pollId);
    }, 250);
  });
})(jQuery);
